import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import dotProp from 'dot-prop-immutable';
import * as actionsTrainingPreview from '@/redux/actions/training/preview';
export var initialState = {
  objects: {}
};

var reducerTrainingPreview = function reducerTrainingPreview() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actionsTrainingPreview.PREVIEW_COURSE_FETCH_ERROR:
    case actionsTrainingPreview.PREVIEW_COURSE_FETCH_START:
      return _objectSpread({}, state);

    case actionsTrainingPreview.PREVIEW_COURSE_FETCH_SUCCESS:
      return dotProp.set(state, "objects.".concat(action.payload.course.slug), action.payload.course);

    default:
      return state;
  }
};

export default reducerTrainingPreview;